interface ErrorWithExtras extends Error {
  statusCode?: number
  response?: unknown
}

interface SerializedError {
  message: string
  name: string
  stack?: string
  statusCode?: number
  response?: unknown
}

/**
 * Serializes Error objects to plain objects for SSR payload serialization
 *
 * XState machines that store errors in context must serialize them to avoid
 * DevalueError "Cannot stringify arbitrary non-POJOs" during SSR.
 *
 * @param error - Error object or any value
 * @returns Plain object with error properties or the original value
 */
export function serializeError(error: unknown): SerializedError | unknown {
  if (error instanceof Error) {
    const extendedError = error as ErrorWithExtras
    return {
      message: error.message,
      name: error.name,
      stack: error.stack,
      statusCode: extendedError.statusCode,
      response: extendedError.response,
    }
  }
  return error
}
